module.exports = "/_next/static/images/customer-review-sarah2-min-3b141a8f88ffe4f7a7282a36e2049d3e.png";